<template>
    <div class="popup-prepartation-container">
        <div class="select-product">
            <div class="title">
                <span class="number">1</span>
                <span class="text">Seleccione el producto</span>
            </div>
            <div class="product-list">
                <div class="product-card" v-for="product in productsList" :key="product.id" @click="selectedProduct = product" :class="{ 'selected': selectedProduct === product }">
                    <i class="i-andy-menu-checklist i-andy-m" v-if="selectedProduct === product"></i>
                    <div class="product-image">
                        <img :src="product.image" alt="product-image"/> 
                    </div>
                    <div class="product-name">{{ product.name }}</div>
                </div>
            </div>
        </div>
        <div class="separator"></div>
        <div class="select-quantity" :class="{ 'no-product-selected': selectedProduct === null }">
            <div class="title">
                <span class="number">2</span>
                <span class="text">Seleccione la cantidad</span>
            </div>
            <div class="numpad-container">
                <Numpad @sendValue="changeValue" @saveAndClose="save" :givenValue="currentValue" :decimal="numpadSettings.decimal" :hasNegative="numpadSettings.hasNegative" :pinType="'numeric'" :newDesing="numpadSettings.newDesing" :quantity="numpadSettings.quantity" :max="numpadSettings.max" :min="numpadSettings.min" :disabled="selectedProduct === null" :preventMobileKeyboard="true"></Numpad>
            </div>
        </div>
    </div>
</template>
<script>
import Numpad from '@/components/inputs/Numpad'
export default {
    name: 'PopupPlsAddProduct',
    components: {
        Numpad
    },
    props: {
        productsList: { type: Object, default: () => {} }
    },
    data() {
        return {
            selectedProduct: null,
            numpadSettings: {
                decimal: false,
                hasNegative: false,
                pinType: 'numeric',
                newDesing: true,
                quantity: true,
                max: 100,
                min: 1
            },
            currentValue: 0

        }
    },
    methods: {
        changeValue(value) {
            this.currentValue = value
        },
        save() {
            if(!this.selectedProduct || this.currentValue === 0) return
            this.$emit('save', {
                product: this.selectedProduct,
                quantity: this.currentValue
            })
        }
    }
}
</script>
<style scoped lang="scss">
.popup-prepartation-container {
    padding: 32px;
    height: 100%;
    width: 100%;
    @include display-flex();
    @include flex-direction(row);
    gap:24px;

    .title {
        @include display-flex();
        @include align-items(center);
        gap:4px;
        .text {
            @include font-size(18px);
            font-family: $text-bold;
            color:$color-black;
        }
        .number {
            color:$color-info-500;
            @include font-size(18px);
            font-family: $text-bold;
            padding: 4px;
            width: 24px;
            height: 24px;
            text-align: center;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: $color-info-100;
            border-radius: 50%;
        }
    }
    .separator {
        border-left: 2px solid $color-neutral-200;
        height: auto;
    }
    .select-product {
        @include display-flex();
        @include flex-direction(column);
        gap: 16px;
        .product-list {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 16px;
            max-height: 400px;
            overflow-y: auto;
            .product-card {
                border: 1px solid $color-neutral-300;
                border-radius: 8px;
                height: 100px;
                min-width: 120px;
                max-width: 150px;
                @include display-flex();
                @include align-items(center);
                gap:4px;
                padding: 8px 16px;
                position: relative;

                i[class^="i-andy-"] {
                    color:$color-primary-500;
                    position: absolute;
                    top: 8px;
                    right: 8px;
                }

                &.selected {
                    border: 1px solid $color-primary-700;
                    background-color: $color-primary-100;
                }

                .product-image {
                    img{
                        width: 24px;
                        height: 100%;
                        object-fit: cover;
                    }
                }
                .product-name {
                    @include font-size(16px);
                    font-family: $text-bold;
                    color:$color-black;
                }
            }
        }
    }

    .select-quantity {
        @include display-flex();
        @include flex-direction(column);
        gap: 16px;
        width: 100%;
        .numpad-container {
            width: 100%;
            @include display-flex();
            @include justify-content(center);
            @include align-items(center);
            @include flex-direction(column);
            width: 100%;
            height: 100%;
        }

        &.no-product-selected {
            pointer-events: none;
            opacity: 0.5;
            filter: grayscale(1);
        }
    }
}
</style>